import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class VideoStreamService {

    private streamResetTriggerSubject: Subject<void> = new Subject<void>();
    streamResetTrigger: Observable<void> = this.streamResetTriggerSubject.asObservable();
    constructor() { }

    resetStreamTimeout(): void {
        this.streamResetTriggerSubject.next();
    }
}
